import { LOCALE } from '../../common/constants';

export default function powerTransformer({ translations = {}, hero, ...power }) {
  return {
    ...power,
    ...translations[LOCALE],
    icon: `${hero.name}_${power.slug.toUpperCase()}`,
    hero,
  };
}
